// Modified PricingTable01.js
import React, { memo } from 'react'

// Libraries
import { Col, Row } from 'react-bootstrap'

// Components
import Buttons from '../../Components/Button/Buttons'

// Data
import { transformAbonnementData } from '../../Components/PricingTable/PricingTableData'


const PricingTable01 = (props) => {
    // Séparer les abonnements populaires et non populaires
    const popularAbonnements = props.data.filter(item => item.popular && item.popular.isPopular);
    const regularAbonnements = props.data.filter(item => !item.popular || !item.popular.isPopular);

    // Supposons que props.isUserLoggedIn indique si l'utilisateur est connecté
    const { isAuthenticated, lang } = props; // Récupère la prop

    // Intercaler les abonnements populaires entre les abonnements non populaires
    const orderedData = [];
    for (let i = 0; i < regularAbonnements.length; i++) {
        orderedData.push(regularAbonnements[i]);
        if (i < popularAbonnements.length) {
            orderedData.push(popularAbonnements[i]);
        }
    }
    return (
        <Row className={`${props.grid} ${props.className}`}>
            {
                orderedData.map((item, i) => {
                    // Déterminer le titre et le lien du bouton en fonction de l'état de connexion et de la langue
                    const buttonTitle = isAuthenticated 
                        ? (lang === 'fr' ? "Acheter abonnement" : "شراء الاشتراك") 
                        : (lang === 'fr' ? "Inscrivez-vous" : "قم بالتسجيل");
                    const buttonLink = item._id
                                        ? (isAuthenticated ? `/checkout_subscription/${item._id}` : "/login")
                                        : "/login"; // Fallback to /login if _id is missing
                    const currency = lang === 'fr' ? 'DT' : 'دينار';
                     return (
                        <Col key={i} className={`${props.theme}${(item.popular && item.popular.isPopular) ? " popular" : ""} ${props.themeColor} flex text-center justify-center rounded-md`} 
                        style={(item.popular && item.popular.color) && {"--popular-bg": item.popular.color}}>
                            <div className="pricing-wrapper">
                                {(item.popular && item.popular.isPopular) && <span className="top-head hidden">Popular</span>}
                                {item.title && <div className="pricing-head font-medium text-lg min-md:text-xlg uppercase font-serif">{item.title}</div>}
                                {item.subtitle && <div className="pricing-sub-head text-sm uppercase mb-[40px]">{item.subtitle}</div>}
                                {item.price && (
                <div className="price-details mb-3">
                  <h3 className="heading-4 price-wrap mb-[5px] -tracking-[1px]">
                    {item.price} {currency}
                  </h3>
                </div>
              )}
                                {item.term && <div className="pricing-head font-medium text-xlg uppercase font-serif">{item.term}</div>}
                                <span className="plans-wrapper block">
                                    <ul className="pl-0 m-0 list-none py-[15px]">
                                        {
                                            item.plans && item.plans.map((item, i) => {
                                                return (
                                                    <li key={i} dangerouslySetInnerHTML={{ __html: item }}></li>
                                                )
                                            })
                                        }
                                    </ul>
                                </span>
                                {
                                    buttonLink && (
                                        (item.popular && item.popular.isPopular) ? (
                                            <Buttons  to={buttonLink} className="btn-fill font-medium font-serif rounded-[4px] uppercase md:mb-[15px]" 
                                            themeColor="#0038e3" color="#fff" size="md" title={buttonTitle} />
                                        ) : (
                                            <Buttons  to={buttonLink} className="btn-fill font-medium font-serif rounded-[4px] uppercase md:mb-[15px]" 
                                            themeColor="#0038e3" color="#fff" size="md" title={buttonTitle} />
                                        )
                                    )
                                }
                            </div>
                        </Col>
                    )
                })
            }
        </Row>

    )
}

PricingTable01.defaultProps = {
    data: []
}

export default memo(PricingTable01)